import React, { Component, Fragment } from "react"
import { NavLink } from 'react-router-dom'
import FormColumn from '../../../Templates/FormColumn'
import { SORT, toggleSorting, checkNotUndefindeNull } from '../../../Templates/functions'
import { nameColumnSkeleton, assignmentColumnSkeleton, numColumnSkeleton, progressColumnSkeleton, multipleEntriesSkeleton } from '../../../Templates/icons'
import axios from 'axios'

class WorkInstructionsWidget extends Component {
    //instantiates new AbortController and assigns it to this.signal
    signal = axios.CancelToken.source()


    state = {
        sortingByTitle: 2,
        sortingByAssignees: 0,
        sortingByAssigned: 0,
        sortingByProgress: 0,
        sortingByStatus: 2,
        isLoading: true ,
        didUpdateOnce: false,
        names:[],
        users: this.props.users || [],
        assignments: [],
    }

    componentDidMount = () => {
        this.loadWorkInstructions()
    }

    componentDidUpdate(prevProps) {
    if (this.props.users !== prevProps.users) {
        if(this.state.didMountOnce === false){
            this.loadWorkInstructions();
            this.setState({didUpdateOnce: true})
        }
        this.setState({users: this.props.users})
    }
}

    componentWillUnmount() {
        this.signal.cancel('Api is being canceled');
    }

    loadWorkInstructions = async () => {
        try {
            await this.props.fetchAllWorkInstructions(this.signal.token)
            this.setState({ isLoading: false })
        } catch (err) {
            if (axios.isCancel(err)) {
                console.info('Work Instruction Overview Widget - ', err.message)
            } else {
                console.debug(err)
                this.setState({isLoading: false})
            }
        }
    }

    addAdditionalInfo = (workInstructions) => {
        let users = this.state.users || []
        let assignments = []
        users.forEach(user => {
            if (user.assignments && Array.isArray(user.assignments)) {
                assignments.push(...user.assignments)
            }
        })
        return workInstructions
    }

    exportContentToCSV = (rows) => {
        let csvContent = "data:text/csv;charset=utf-8," 
            + rows.map(row => row.join(",")).join("\n");

        var encodedUri = encodeURI(csvContent);
        window.open(encodedUri);
    }


    // Create a lookup object (HASHMAP) for user.assignments based on WIPID
    createAssignmentsLookup = () => {
        const lookup = {};
        this.state.users.forEach(user => {
            if (user?.assignments?.length > 0) {
                user.assignments.forEach(assign => {
                    if (!lookup[assign.WIPID]) {
                        lookup[assign.WIPID] = [];
                    }
                    lookup[assign.WIPID].push(user.username);
                });
            }
        });
        return lookup;
    }


    getAsignneeNames = (wipID)=>{
        const lookup = this.createAssignmentsLookup();
        return lookup[wipID] ? lookup[wipID].join(', ') : '';
    }

    getWorkStatus = (workInstruction) => {
        let workStatus = '';
        if(workInstruction.release === false){
            workStatus = "Not Published";
        }else if(workInstruction.release === true && workInstruction.workStatus === 'Not Started'){
            workStatus = `Published - ${workInstruction.workStatus}`;
        }else{
            workStatus = workInstruction.workStatus;
        }
        return workStatus;
    }

    render() {
        let workInstructions = this.props.workInstructions || []
        if (this.state.isLoading) {
            this.addAdditionalInfo(workInstructions)
        } 

        if (this.state.sortingByAssignees) {
            workInstructions = SORT(this.state.sortingByAssignees, workInstructions, "assignees")
        }
        if (this.state.sortingByAssigned) {
            workInstructions = SORT(this.state.sortingByAssigned, workInstructions, "assignees", true)
        }
        // CHANGE
        if (this.state.sortingByProgress) {
            workInstructions = SORT(this.state.sortingByProgress, workInstructions, "completion")
        }

        if (this.state.sortingByTitle) {
            workInstructions = SORT(this.state.sortingByTitle, workInstructions, "title")
        }

        let names = []
        let tags = []

        workInstructions.forEach(wi => {
            names.push(wi.title)
            if (typeof wi.tags != "undefined" && wi.tags.length === 0) {
                tags.push(<p style={{textAlign: "center"}}>-</p>)
            } else {
                let tagsString = ""
                //wi has an array of tag ids that .populate with a tag name on the backend.
                wi.tags.forEach(tag => {
                    tagsString += " #" + tag.name
                    // tagsArray.push(<p className="wi-overview title" key={`work-instruction ${wi._id} tag ${tag._id}`}>{`#${tag.name}`}</p>)
                })
                tags.push(tagsString)
            } 
        })
        


        let assignees = []
        let workStatus = []
        let assingeeNames = []


        let assignmentStatus = workInstructions.map(workInstruction => {
            workStatus.push(this.getWorkStatus(workInstruction));
            assignees.push(workInstruction.assignees)
            if (assignees[assignees.length-1] > 0 && checkNotUndefindeNull(this.state.users) && this.state.users.length > 0){
                assingeeNames.push(this.getAsignneeNames(workInstruction._id))
            }else{
                assingeeNames.push("NA")
            }
        })


        return (
        <div id="wi-overview-container" className={`feed-item-wide shadow ${this.props.gridlabel}`}>
                    <NavLink id="widget-link" className="flex-centered clickable FontSize20" to={`/dashboard/work instructions parent`}
                        draggable={false}>WORK INSTRUCTION OVERVIEW
                    </NavLink>
                    {/* <span className="export-data-button clickable" onClick={() => this.exportContentToCSV([names])}>Export Data</span> */}
                <div id="columns-container" className="wi-overview-columns flex overflow-y">
                    {this.state.isLoading ? 
                        <Fragment>
                            <FormColumn title={"Title"} sort={() => toggleSorting(this.state.sortingByTitle, (value) => this.setState({ sortingByTitle: value, sortingByAssigned: 0, sortingByAssignees: 0, sortingByProgress: 0 }))} sorting={this.state.sortingByTitle} content={nameColumnSkeleton} contentType={"text"} columnWidth={"calc(50% - 1px)"} /> {/*32*/}
                            {/* <FormColumn title={"Tag"} content={multipleEntriesSkeleton} numColumns={5} nullSort={true} columnWidth={"calc(25% - 1px)"}/>29 */}
                            {/* <FormColumn ellipsisAlt={true} title={"Assignment Status"} sort={() => toggleSorting(this.state.sortingByAssigned, (value) => this.setState({ sortingByAssigned: value, sortingByAssignees: 0, sortingByProgress: 0, sortingByTitle: 0 }))} contentType={"other"} sorting={this.state.sortingByAssigned} content={assignmentColumnSkeleton} columnWidth={"calc(15% - 1px)"} />15 */}
                            <FormColumn title={"Assignee"} sort={() => toggleSorting(this.state.sortingByAssignees, (value) => this.setState({ sortingByAssignees: value, sortingByProgress: 0, sortingByAssigned: 0, sortingByTitle: 0 }))} contentType={"numbers"} sorting={this.state.sortingByAssignees} content={numColumnSkeleton} columnWidth={"calc(25% - 1px)"} />{/*10*/}
                            <FormColumn title={"Progress"} sort={() => toggleSorting(this.state.sortingByProgress, (value) => this.setState({ sortingByProgress: value, sortingByAssignees: 0, sortingByAssigned: 0, sortingByTitle: 0 }))} contentType={"amount"} sorting={this.state.sortingByProgress} content={progressColumnSkeleton} columnWidth={"calc(25% - 1px)"} skeleton={true}/>{/*12*/}
                        </Fragment> 
                        :
                        <Fragment>
                            <FormColumn title={"Title"} sort={() => toggleSorting(this.state.sortingByTitle, (value) => this.setState({ sortingByTitle: value, sortingByAssigned: 0, sortingByAssignees: 0, sortingByProgress: 0 }))} sorting={this.state.sortingByTitle} content={names} contentType={"text"} columnWidth={"calc(50% - 1px)"}/>{/*32*/}
                            {/* <FormColumn title={"Tag"} content={tags} columnWidth={"calc(25% - 1px)"} nullSort={true}/>29 */}
                            {/* <FormColumn ellipsisAlt={true} title={"Assignment Status"} sort={() => toggleSorting(this.state.sortingByAssigned, (value) => this.setState({ sortingByAssigned: value, sortingByAssignees: 0, sortingByProgress: 0, sortingByTitle: 0 }))} contentType={"other"} sorting={this.state.sortingByAssigned} content={assignmentStatus} columnWidth={"calc(15% - 1px)"}/>15 */}
                            <FormColumn title={"Assignee"} sort={() => toggleSorting(this.state.sortingByAssignees, (value) => this.setState({ sortingByAssignees: value, sortingByProgress: 0, sortingByAssigned: 0, sortingByTitle: 0 }))} contentType={"text"} sorting={this.state.sortingByAssignees} content={assingeeNames} columnWidth={"calc(25% - 1px)"}/>{/*10*/}
                            <FormColumn title={"Status"} sort={() => toggleSorting(this.state.sortingByProgress, (value) => this.setState({ sortingByProgress: value, sortingByAssignees: 0, sortingByAssigned: 0, sortingByTitle: 0 }))} contentType={"amount"} sorting={this.state.sortingByProgress} content={workStatus} columnWidth={"calc(25% - 1px)"}/>{/*12*/}
                        </Fragment>}
                </div>
            </div>
        )
    }
}

export default WorkInstructionsWidget
